import { useDataState } from "./data";

export const useExchanges = () => {
  const exchanges = useDataState().exchanges;

  const getExchange = (exchangeName: string) => {
    return exchanges.find((exchange) => exchange.name === exchangeName);
  };

  return {
    exchanges,
    getExchange,
  };
};
